import { DrawerHeader } from '@components/drawerItem/DrawerHeader';
import { Box, Typography } from '@mui/material';
import { DrawerContent } from '@components/drawerItem/DrawerContent';
import { useGetScreenSize } from '@utils/useGetScreenSize';
import { treeItem, treeItemStyles } from '@pages/PortalAdmin/sidebarItems/brokerageManager/BrokerageManagerTree.styles';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { treeItems } from '@pages/PortalAdmin/sidebarItems/advancedPortalData/AdvancedPortalDataSideBar.constants';
import { IconButton } from '@components/iconButton';
import { Tooltip } from '@components/tooltip/Tooltip';
import { ChevronLeft } from '@assets/svgs';
import { isModifiedClick } from '@utils/clickEvents';

export const AdvancedPortalDataSideBar = ({
  onBack = () => {},
  onClose,
}: {
  onBack?: () => void;
  onClose: (e: React.MouseEvent) => void;
}) => {
  const { isMobileOrSmallScreen } = useGetScreenSize();
  const location = useLocation();
  const isActive = (path: string) => location.pathname.includes(path);

  const selectedItem = treeItems.find((item) => isActive(item.url));

  return (
    <>
      {isMobileOrSmallScreen ? (
        <DrawerHeader drawerTitle='Advanced Portal Configuration' onClose={onClose} />
      ) : (
        <Box
          sx={{
            borderBottomStyle: 'solid',
            borderWidth: '1px',
            borderColor: 'divider',
            padding: 0,
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              borderBottom: '1px solid',
              borderColor: 'divider',
              display: 'flex',
              gap: 1.25,
              p: 1.5,
            }}
          >
            <Tooltip title='Back to Portal Admin navigation'>
              <IconButton
                aria-label='Back to Portal Admin navigation'
                onClick={onBack}
                size='small'
                variant='rounded'
                sx={{
                  backgroundColor: 'common.white',
                  border: '1px solid',
                  borderColor: 'divider',
                  color: 'secondary.main',
                  flexShrink: 0,
                  height: 36,
                  width: 36,
                }}
              >
                <ChevronLeft width={16} height={16} />
              </IconButton>
            </Tooltip>
            <Box>
              <Typography
                display='block'
                variant='bodySmall'
                sx={{
                  color: 'text.secondary',
                  fontWeight: 600,
                  letterSpacing: 0,
                  textTransform: 'uppercase',
                }}
              >
                System
              </Typography>
              <Typography
                display='block'
                variant='bodySmall'
                fontWeight={600}
                sx={{ color: 'text.main', fontSize: 14, lineHeight: 1.25 }}
              >
                Advanced Portal Configuration
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      <DrawerContent drawerColor='common.white' drawerPadding='0'>
        <Box sx={{ padding: 0, paddingTop: 1, height: '100%', overflowY: 'scroll' }}>
          <SimpleTreeView sx={treeItem} selectedItems={selectedItem?.url ?? ''}>
            {treeItems.map((item) => (
              <TreeItem
                sx={treeItemStyles}
                key={item.url}
                itemId={item.url}
                label={
                  <Box
                    component={RouterLink}
                    to={`/portal-admin/advanced-portal-configuration/${item.url}`}
                    onClick={(e) => {
                      // Navigation is handled by the link itself; only close the mobile drawer for
                      // a plain left-click, so a ctrl/cmd/shift/middle-click that opens a new tab
                      // doesn't also close the drawer in the current one.
                      if (isModifiedClick(e)) return;
                      onClose(e);
                    }}
                    sx={{
                      display: 'flex',
                      minWidth: 0,
                      textDecoration: 'none',
                    }}
                  >
                    <Typography noWrap variant='bodySmall' display='block' fontWeight={isActive(item.url) ? 500 : 400}>
                      {item.label}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </SimpleTreeView>
        </Box>
      </DrawerContent>
    </>
  );
};
